import { Link } from "react-router-dom";
import Typography from "../Typography";
import { NothingFoundWrapper } from "./styled";

export const NothingFound = ({ onClick }) => {
  return (
    <NothingFoundWrapper>
      <img src="/nothing-found.svg" alt="Ничего не найдено!" />
      <Typography variant="h1">Ничего не найдено!</Typography>
      <Typography color="secondary">
        Но у нас много интересного на главной
      </Typography>
      <Link to="/" onClick={onClick}>
        <Typography semibold> На главную</Typography>
      </Link>
    </NothingFoundWrapper>
  );
};
